// extracted by mini-css-extract-plugin
export default {"container":"InfoMessage_container__dcnLe","message":"InfoMessage_message__ix7UU","closeButton":"InfoMessage_closeButton__JdADI"};